import Api from '@/services/Api'
// import { log } from 'util';

export default {
  testping(query) {
    return Api().get('pondi/testping', {
      params: query
    })
  },
  testams(query) {
    return Api().get('pondi/testams', {
      params: query
    })
  },
  testxml(doc) {
    return Api().post('pondi/testxml', doc)
  },
  sendxml(doc) {
    return Api().post('pondi/sendxml', doc)
  },
  getxml(query) {
    return Api().get('pondi/getxml', {
      params: query
    })
  },
  getvisualxml(query) {
    return Api().get('pondi/getvisualxml', {
      params: query
    })
  },
  getulazni(query) {
    return Api().get('pondi/getulazni', {
      params: query
    })
  },
  getizlazni(query) {
    return Api().get('pondi/getizlazni', {
      params: query
    })
  },
  getstatusdok(query) {
    return Api().get('pondi/getstatusdok', {
      params: query
    })
  },
  promjenastatus(doc) {
    return Api().post('pondi/promjenastatus', doc)
  },

  // eizvjestavanje
  evidentirajdokument(doc) {
    return Api().post('pondi/evidentirajdokument', doc)
  },
  oznacinaplacenid(doc) {
    return Api().post('pondi/oznacinaplacenid', doc)
  },
  oznacinaplacen(doc) {
    return Api().post('pondi/oznacinaplacen', doc)
  },
  oznaciodbijenid(doc) {
    return Api().post('pondi/oznaciodbijenid', doc)
  },
  oznaciodbijen(doc) {
    return Api().post('pondi/oznaciodbijen', doc)
  },
  eizvjestavanjereport(search) {
    return Api().get('pondi/eizvjestavanjereport', {
      params: search
    })
  }
}